import React, { useState } from 'react';
import InventoryIcon from '../../../Svgs/InventoryIcon';
import ParkingLotIcon from '../../../Svgs/ParkingLotIcon';
import ReturnIcon from '../../../Svgs/ReturnIcon';
import SupportIcon from '../../../Svgs/SupportIcon';
import LogOutIcon from '../../../Svgs/LogOutIcon';
import SettingNavIcon from '../../../Svgs/SettingNavIcon';
import '../../../assets/styles/global.scss';
import '../styles/nav.scss';
function CustomLink(props) {
    return (
        <div className={`p-b-3 p-t-3 flex m-t-10 cursor-pointer ${props.selected ? 'selectedNav' : 'p-l-10'}`}
            onClick={() => props.onSelectionChange(props.type)}
        >
            <div className="icon-box">
                {props.type === "inventory" && <InventoryIcon />}
                {props.type === "parkingLot" && <ParkingLotIcon />}
                {props.type === "return" && <ReturnIcon />}
                {props.type === "support" && <SupportIcon />}
                {props.type === "logout" && <LogOutIcon />}
                {props.type === "setting" && <SettingNavIcon />}
            </div>
            <div className="icon-text">
                {props.type === "inventory" && "Inventory"}
                {props.type === "parkingLot" && "Parking Lot"}
                {props.type === "return" && "Returns"}
                {props.type === "support" && "Support"}
                {props.type === "logout" && "Logout"}
                {props.type === "setting" && "Settings"}
            </div>
        </div>
    );
}

export default CustomLink;